module.exports = __webpack_public_path__ + "img/14_Responsible Citizen.0e2db171.svg";